import React from 'react';
import {Row} from "react-flexbox-grid";
import { DatePicker } from 'antd';
import Moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { CalendarOutlined } from '@ant-design/icons';

const PreEDate = ({ preEForm, onChangePreEDate, saveVisibleText }) =>
  <Row controlId='energizationDate' style={{alignItems: 'center'}}>
    <label className='col-xs-12 col-sm-2' style={{ margin: 0}}>Energization Date:*</label>
    <DatePicker
      autoComplete="off"
      format={'MMMM DD, YYYY'}
      suffixIcon={<CalendarOutlined />}
      id="energizationDate"
      size={"large"}
      className='col-xs-12 col-sm-4'
      onChange={onChangePreEDate}
      disabled={!saveVisibleText}
      value={preEForm && preEForm.preEnergizationDate ? Moment(preEForm.preEnergizationDate) : preEForm.preEnergizationDate}
    />
  </Row>

export default PreEDate;
